<div class="container-fluid py-4">
  <!-- Loading State -->
  <div v-if="loading" class="text-center mt-5">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3 text-muted">Loading questions...</p>
  </div>

  <!-- Main Content -->
  <div v-else>
    <div class="row">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <!-- Card Header -->
          <div class="card-header bg-white border-bottom py-3">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h5 class="mb-1 fw-bold text-dark">{{ service_name }}</h5>
                <p class="mb-0 text-muted small">Select questions to include in your register form</p>
              </div>
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="go_back">
                <i class="fas fa-arrow-left me-1"></i>Back
              </button>
            </div>
          </div>

          <!-- Card Body -->
          <div class="card-body p-4">
            <!-- Filters Section -->
            <div class="row g-3 mb-4">
              <div class="col-md-4">
                <label class="form-label small fw-semibold text-muted mb-1">Filter by Service Type</label>
                <select class="form-select form-select-sm" v-model="selected_service_type" @change="fetch_service_type_questions">
                  <option value="all">All Questions</option>
                  <option v-for="type in service_types" :key="type.id" :value="type.id">{{ type.type }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label small fw-semibold text-muted mb-1">Search Questions</label>
                <input type="text" class="form-control form-control-sm" placeholder="Type to search..." v-model="search_query" @input="filter_questions">
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <span class="badge bg-primary w-100 py-2">{{ selected_questions.length }} selected</span>
              </div>
            </div>

            <!-- Questions Table -->
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="bg-light">
                  <tr>
                    <th class="text-center text-muted small fw-semibold" style="width: 50px;">
                      <input type="checkbox" class="form-check-input" @change="toggle_all_questions" :checked="all_questions_selected" style="cursor: pointer;">
                    </th>
                    <th class="text-uppercase text-muted small fw-semibold">Question</th>
                    <th class="text-uppercase text-muted small fw-semibold" style="width: 120px;">Type</th>
                    <th class="text-uppercase text-muted small fw-semibold" style="width: 150px;">Service Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="filtered_questions.length === 0">
                    <td colspan="4" class="text-center py-4">
                      <i class="fas fa-inbox fa-2x text-muted mb-2 d-block opacity-50"></i>
                      <p class="text-muted small mb-0">No questions available</p>
                    </td>
                  </tr>
                  <tr v-for="question in filtered_questions" :key="question.id" :class="{ 'table-primary': selected_questions.includes(question.id) }">
                    <td class="text-center">
                      <input type="checkbox" class="form-check-input" v-model="selected_questions" :value="question.id" style="cursor: pointer;">
                    </td>
                    <td>
                      <span class="text-dark">{{ question.question }}</span>
                    </td>
                    <td>
                      <span class="badge bg-secondary">{{ question.question_type || 'N/A' }}</span>
                    </td>
                    <td>
                      <span class="badge bg-info">{{ question.service_type || 'N/A' }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <!-- Card Footer -->
          <div class="card-footer bg-white border-top py-3">
            <div class="d-flex justify-content-between align-items-center">
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="go_back">
                <i class="fas fa-times me-1"></i>Cancel
              </button>
              <button type="button" class="btn btn-success" @click="save_questions" :disabled="selected_questions.length === 0">
                <i class="fas fa-save me-1"></i>Save Questions ({{ selected_questions.length }})
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
